/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:100%;display:block;position:relative;max-height:384px;min-height:384px;margin-top:16px;margin-bottom:8px}canvas.empty[_ngcontent-%COMP%]{opacity:.2}"];
export { styles as styles };
